import type { IconData } from '@stacksjs/iconify-core'

export const bookF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 18V1H3v17H0V0h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3zM6 4v2h5V4zm0 3v2h5V7zM3 18h2v2H3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bookF
